// src/components/InvoiceDetails.js
import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Box,
  Grid
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';


const InvoiceDetails = ({ invoice }) => {
  const [openRows, setOpenRows] = React.useState({});

  const handleRowClick = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (!invoice) return null;

  return (
    <Paper elevation={3} sx={{ padding: 4, marginBottom: 4 }}>
      <Typography variant="h5" gutterBottom>
        Invoice Details (ID: {invoice.id})
      </Typography>
      <Box sx={{ mb: 3 }}>
        <Typography><strong>Konto:</strong> {invoice.Konto}</Typography>
        <Typography><strong>Datum:</strong> {invoice.Datum}</Typography>
        <Typography><strong>Leistungsdatum:</strong> {invoice.Leistungsdatum}</Typography>
        <Typography><strong>Beleg1:</strong> {invoice.Beleg1}</Typography>
        <Typography><strong>Beleg2:</strong> {invoice.Beleg2}</Typography>
        <Typography><strong>AN:</strong> {invoice.AN}</Typography>
        <Typography><strong>BN:</strong> {invoice.BN}</Typography>
        <Typography><strong>Gkto:</strong> {invoice.Gkto}</Typography>
        <Typography><strong>Buchungsnumber:</strong> {invoice.Buchungsnumber}</Typography>
        <Typography><strong>BU:</strong> {invoice.BU}</Typography>
        <Typography><strong>Soll:</strong> {invoice.Soll}</Typography>
        <Typography><strong>Haben:</strong> {invoice.Haben}</Typography>
        <Typography><strong>Kost1:</strong> {invoice.Kost1}</Typography>
        <Typography><strong>Kost2:</strong> {invoice.Kost2}</Typography>
      </Box>
      <Typography variant="h6" gutterBottom>
        Items:
      </Typography>
      {invoice.items.length === 0 ? (
        <Typography>No items added yet.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="invoice items table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>ID</TableCell>
                <TableCell>Position</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Materialbuchung</TableCell>
                <TableCell>Description</TableCell>
                {/* Add more headers as needed */}
              </TableRow>
            </TableHead>
            <TableBody>
              {invoice.items.map((item) => (
                <React.Fragment key={item.id}>
                  <TableRow>
                    <TableCell>
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => handleRowClick(item.id)}
                      >
                        {openRows[item.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </IconButton>
                    </TableCell>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.position}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.materialbuchung}</TableCell>
                    <TableCell>{item.description}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                      <Collapse in={openRows[item.id]} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                          <Typography variant="subtitle1" gutterBottom component="div">
                            Details
                          </Typography>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                              <Typography><strong>Single Stuck Cost:</strong> {item.singleStuckCost}</Typography>
                              <Typography><strong>Number Of Stuck:</strong> {item.numberOfStuck}</Typography>
                              <Typography><strong>Total Stuck Cost:</strong> {item.totalStuckCost}</Typography>
                              <Typography><strong>ANR:</strong> {item.ANR}</Typography>
                              <Typography><strong>Percentage:</strong> {item.percentage}</Typography>
                              <Typography><strong>Percentage2:</strong> {item.percentage2}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography><strong>Total Ton:</strong> {item.totalTon}</Typography>
                              <Typography><strong>Cost Per Ton:</strong> {item.costPerTon}</Typography>
                              <Typography><strong>Bestullung Nr:</strong> {item.bestullungNr}</Typography>
                              <Typography><strong>Rechnuunglefrant:</strong> {item.rechnuunglefrant}</Typography>
                              <Typography><strong>Aufrag Nr:</strong> {item.aufragNr}</Typography>
                              <Typography><strong>Wandstärke:</strong> {item.Wandstärke}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="subtitle2"><strong>Materials:</strong></Typography>
                              <Typography>Material1: {item.Material1}</Typography>
                              <Typography>Material2: {item.Material2}</Typography>
                              <Typography>Material3: {item.Material3}</Typography>
                              <Typography>Material4: {item.Material4}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="subtitle2"><strong>Abmessang:</strong></Typography>
                              {item.Abmessang.map((abm, idx) => (
                                <Typography key={idx}>
                                  {abm.name}: {abm.value} {abm.unit}
                                </Typography>
                              ))}
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default InvoiceDetails;
